// export const BASEURL = 'http://192.168.1.46:5000'
// export const BASEURL = 'http://localhost:5000'
// export const BASEURL = 'http://147.79.67.218:5000'
export const BASEURL = 'https://medical.sculptskincare.cloud/api'

// export const BASEURL = 'http://localhost:5000'

export const BARCODE_URL = 'http://localhost:3000'